/**
 * Navigation Event System
 * Allows components outside of the Router context to trigger navigation
 */

export const NAVIGATION_EVENT = "app:navigate";
export const TOGGLE_GRID_LOCK_EVENT = "app:toggleGridLock";
export const START_TRANSMISSION_EVENT = "app:startTransmission";

export interface NavigationEventDetail {
  path: string;
}

export const emitNavigationEvent = (path: string) => {
  const event = new CustomEvent<NavigationEventDetail>(NAVIGATION_EVENT, {
    detail: { path },
  });
  window.dispatchEvent(event);
};

export const subscribeToNavigationEvents = (callback: (path: string) => void): (() => void) => {
  const handler = (event: Event) => {
    const customEvent = event as CustomEvent<NavigationEventDetail>;
    callback(customEvent.detail.path);
  };

  window.addEventListener(NAVIGATION_EVENT, handler);

  // Return unsubscribe function
  return () => {
    window.removeEventListener(NAVIGATION_EVENT, handler);
  };
};

export const emitToggleGridLockEvent = () => {
  const event = new CustomEvent(TOGGLE_GRID_LOCK_EVENT);
  window.dispatchEvent(event);
};

export const subscribeToGridLockEvents = (callback: () => void): (() => void) => {
  const handler = () => {
    callback();
  };

  window.addEventListener(TOGGLE_GRID_LOCK_EVENT, handler);

  // Return unsubscribe function
  return () => {
    window.removeEventListener(TOGGLE_GRID_LOCK_EVENT, handler);
  };
};

export const emitStartTransmissionEvent = () => {
  const event = new CustomEvent(START_TRANSMISSION_EVENT);
  window.dispatchEvent(event);
};

export const subscribeToTransmissionEvents = (callback: () => void): (() => void) => {
  const handler = () => {
    callback();
  };

  window.addEventListener(START_TRANSMISSION_EVENT, handler);

  // Return unsubscribe function
  return () => {
    window.removeEventListener(START_TRANSMISSION_EVENT, handler);
  };
};

export const ADD_WIDGET_EVENT = "app:addWidget";

export const emitAddWidgetEvent = () => {
  const event = new CustomEvent(ADD_WIDGET_EVENT);
  window.dispatchEvent(event);
};

export const subscribeToAddWidgetEvents = (callback: () => void): (() => void) => {
  const handler = () => {
    callback();
  };

  window.addEventListener(ADD_WIDGET_EVENT, handler);

  // Return unsubscribe function
  return () => {
    window.removeEventListener(ADD_WIDGET_EVENT, handler);
  };
};

export const OPEN_STREAM_SETTINGS_EVENT = "app:openStreamSettings";

export const emitOpenStreamSettingsEvent = () => {
  const event = new CustomEvent(OPEN_STREAM_SETTINGS_EVENT);
  window.dispatchEvent(event);
};

export const subscribeToOpenStreamSettingsEvents = (callback: () => void): (() => void) => {
  const handler = () => {
    callback();
  };

  window.addEventListener(OPEN_STREAM_SETTINGS_EVENT, handler);

  // Return unsubscribe function
  return () => {
    window.removeEventListener(OPEN_STREAM_SETTINGS_EVENT, handler);
  };
};
